import Vue from 'vue'
import Vuex from 'vuex'
import { loginApi, registerApi, logoutApi } from '../api/login';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showLoginModal: false,
    activeLoginTab: 'login',
    isLoggedIn: false,
    user: {
      avatar: '',
    },
    token: null
  },
  mutations: {
    UPDATE_USER_AVATAR(state, avatar) {
      state.user.avatar = avatar;
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      user.avatar = avatar;
      localStorage.setItem('user', JSON.stringify(user));
    },
    UPDATE_USER_INFO(state, user) {
      state.user = {...state.user, ...user};
      localStorage.setItem('user', JSON.stringify(state.user));
    },
    OPEN_LOGIN_MODAL(state, tabName = 'login') {
      state.showLoginModal = true
      state.activeLoginTab = tabName
    },
    CLOSE_LOGIN_MODAL(state) {
      state.showLoginModal = false
    },
    SET_ACTIVE_TAB(state, tabName) {
      state.activeLoginTab = tabName
    },
    SET_LOGIN(state, { user, token }) {
      state.isLoggedIn = true
      state.user = user
      state.token = token
      localStorage.setItem('token', token)
      localStorage.setItem('user', JSON.stringify(user))
    },
    LOGOUT(state) {
      state.isLoggedIn = false
      state.user = null
      state.token = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    }
  },
  actions: {
    // login({ commit }, credentials) {
    //   return new Promise((resolve) => {
    //     // 模拟API请求
    //     setTimeout(() => {
    //       if (credentials.username === 'admin' && credentials.password === '123456') {
    //         commit('SET_LOGIN', { name: 'Admin' })
    //         resolve(true)
    //       } else {
    //         resolve(false)
    //       }
    //     }, 500)
    //   })
    // }
    logout({ commit }) {
      return logoutApi().then(response => {
        commit('LOGOUT')
        return true
      }).catch(error => {
        commit('LOGOUT')
        return Promise.reject(error)
      })
    },
    login({ commit }, credentials) {
      return loginApi(credentials).then(response => {
        // 接口成功返回
        if(response.data.code == 1){
          commit('SET_LOGIN', {
            user: response.data.data.userinfo,
            token: response.data.data.userinfo.token
          })
          return true;
        }else{
          return false;
        }
        // return true 
      }).catch(error => {
        // console.error('登录失败:', error.response?.data?.message || error.message)
        return false
      })
    },
    register({ commit }, userData) {
      return registerApi(userData).then(response => {
        console.log(response,'response')
        if(response.data.code == 1){
          return true
        }else{
          return Promise.reject(response.data.message || '注册失败')
        }
      }).catch(error => {
        console.error('注册失败:', error)
        // return Promise.reject(error.response?.data?.message || '注册请求失败')
      })
    }
  }
})


// WEBPACK FOOTER //
// ./src/store/store.js